<mat-accordion multi="true">

  <mat-expansion-panel class="newOffsetPanel"
                       [expanded]="true">
    <mat-expansion-panel-header class="blueHeader">
      {{"NEW_OFFSET"|translate}}
    </mat-expansion-panel-header>

    <div class="panel">
      <div id="newOffsetForm" class="panelContent">
        <div class="fields-row">
          <div class="offset-field">
              <input [(ngModel)]="offsetValue" (ngModelChange)="onOffsetValueChange()"
                     type="number"
                     step="0.001"
                     [placeholder]="'VALUE' | translate">
            <label *ngIf="!!currentLocationUnit">{{currentLocationUnit}}</label>
          </div>
          <div class="offset-field disabled" *ngIf="selectedLocation.length > 0">
            <input [value]="offsetValueModified"
                   type="number" disabled>
            <label>mm</label>
          </div>
          <div>||</div>
          <div id="datePickerCont" style="display: flex; align-items: center">
            <input id="datePickerInput"
                   placeholder="Choose a date"
                   matInput
                   [matDatepicker]="picker"
                   [(ngModel)]="datePicker">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker style="display: block"></mat-datepicker>
            <ngb-timepicker [(ngModel)]="timePicker" [seconds]="true"
                            [disabled]="disabled"></ngb-timepicker>
          </div>
        </div>
        <div style="margin-top: 20px">
                              <textarea cols="90" rows="2" class="block"
                                        [(ngModel)]="comment"
                                        [placeholder]="'COMMENTS' | translate"></textarea>
        </div>
      </div>
      <div class="panelFooter">
        <mat-radio-group (change)="switchOffsetsDirection($event.value)"
                         class="offset-direction-group"
                         aria-label="Select an offset option">
          <mat-radio-button [value]=true>{{'INVERTED_OFFSETS' | translate}}</mat-radio-button>
          <mat-radio-button [value]=false
                            checked="true">{{'NOT_INVERTED_OFFSETS' | translate}}</mat-radio-button>
        </mat-radio-group>
        <button (click)="submit()"
                id="submitOffsetButt"
                class="btn btn-success">
          {{ 'VALIDATE' | translate }}
        </button>
      </div>
    </div>

  </mat-expansion-panel>


  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header class="blueHeader">
      {{"OFFSET_TABLE"|translate}}
    </mat-expansion-panel-header>
    <div class="panel">
      <div class="panelContent">
        <table>
          <thead>
          <tr class="tableLabels">
            <th style="width: 140px">{{ 'VALUE' | translate }}</th>
            <th style="width: 170px">{{ 'DATE' | translate }}</th>
            <th style="width: 100px">{{ 'DIRECTION' | translate }}</th>
            <th style="width: 200px">{{ 'COMMENTS' | translate }}</th>
            <th style="width: 0"></th>
          </tr>
          </thead>
          <tbody *ngIf="selectedLocationDataProcessMeasures">
          <tr *ngFor="let offset of selectedLocationDataProcessMeasures; let i = index">
            <th>
              <span *ngIf="!offset.selected">{{offset.value}}</span>
              <input class="inputSmall"
                     #offsetValue
                     *ngIf="offset.selected"
                     [value]="offset.value"
                     (input)="offset.new_value = offsetValue.value"
                     type="number"
                     step="0.001">
            </th>
            <th *ngIf="!offset.selected">{{offset.dateToDisplay}}</th>
            <th *ngIf="offset.selected">
              <input class="datePickerInputChange datePickerInputChangeCont"
                     style="width: 70% !important;" matInput
                     [matDatepicker]="picker"
                     placeholder="Choose a date"
                     [(ngModel)]="datePickerPatchOffset">
              <mat-datepicker-toggle matSuffix
                                     [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <ngb-timepicker [(ngModel)]="timePickerPatchOffset" [seconds]="true"
                              [disabled]="disabled"></ngb-timepicker>
            </th>
            <th>
                                                      <span *ngIf="!offset.selected">
                                                          {{(offset.invertedDirection ? "PAST" : "FUTURE") | translate}}
                                                      </span>
              <mat-slide-toggle *ngIf="offset.selected"
                                [checked]="offset.invertedDirection"
                                (change)="offset.invertedDirection = $event.checked">
                {{(offset.invertedDirection ? "PAST" : "FUTURE") | translate}}
              </mat-slide-toggle>
            </th>
            <th class="comments">
              <span *ngIf="!offset.selected">{{offset.comment}}</span>
              <input class="inputLarge"
                     #offsetComment
                     *ngIf="offset.selected"
                     [value]="offset.comment || ''"
                     (input)="offset.new_comment = offsetComment.value">
            </th>
            <th class="buttons-cont"
                [ngClass]="offset.selected ? 'submitUpdateCont' : ''">
              <div class="button-cont-inner edit"
                   *ngIf="!offset.selected">
                <button class="btn btn-info"
                        (click)="setDatePatchOffset(offset.date, i)"
                        [ngbTooltip]="'UPDATE' | translate">
                  <fa-icon [icon]="faPen">
                  </fa-icon>
                </button>
                <button class="btn btn-warning"
                        (click)="deleteDataProcessMeasures(offset.id)"
                        [ngbTooltip]="'DELETE' | translate">
                  <fa-icon [icon]="faTrash">
                  </fa-icon>
                </button>
              </div>
              <div class="button-cont-inner validation" *ngIf="offset.selected">
                <button class="btn btn-warning"
                        (click)="offset.selected = undefined"
                        class="bootstrapStyle btn btn-primary offsetStyleButt deleteOffsetButt">
                  {{ 'CANCEL' | translate }}
                </button>
                <button class="bootstrapStyle btn btn-warning"
                        (click)="patchDataProcessMeasures(offset)">
                  {{ 'VALIDATE' | translate }}
                </button>
              </div>
            </th>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-expansion-panel>

</mat-accordion>
